import { render, staticRenderFns } from "./DepartmentView.vue?vue&type=template&id=6b0a4654&scoped=true"
import script from "./DepartmentView.vue?vue&type=script&lang=js"
export * from "./DepartmentView.vue?vue&type=script&lang=js"
import style0 from "./DepartmentView.vue?vue&type=style&index=0&id=6b0a4654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a4654",
  null
  
)

export default component.exports